import _defineProperty from '@babel/runtime/helpers/defineProperty';
import styled, { css } from 'styled-components';
import { siteThemes, theme, isDefaultTheme, isGlobetrotter } from '../../utils/theming.js';
import mq from '../../utils/mediaQueries.js';

var DEFAULT = siteThemes.DEFAULT,
  GLOBETROTTER = siteThemes.GLOBETROTTER;
var color = theme('site', _defineProperty(_defineProperty({}, DEFAULT, 'var(--color-core-500)'), GLOBETROTTER, 'var(--color-logo)'));
var fontWeight = theme('site', _defineProperty(_defineProperty({}, DEFAULT, 700), GLOBETROTTER, 400));
var Rating = styled.div.attrs(function (props) {
  return {
    'aria-label': props['aria-label']
  };
}).withConfig({
  displayName: "Ratingstyle__Rating",
  componentId: "sc-1cmhm0l-0"
})(["align-items:center;color:", ";cursor:default;display:inline-flex;font-size:", "rem;font-weight:", ";user-select:none;svg{", " ", "}"], color, function (props) {
  return props.$size === 's' ? 1.9 : 2.5;
}, fontWeight, isDefaultTheme(css(["margin-right:3px;height:", "rem;width:", "rem;", ""], function (props) {
  return props.$size === 's' ? 2.1 : 2.8;
}, function (props) {
  return props.$size === 's' ? 2.1 : 2.8;
}, function (props) {
  return props.$responsive && css(["", ""], mq.sMax(css(["height:2.1rem;width:2.1rem;"])));
})), isGlobetrotter(css(["margin-right:var(--space-100);height:", "rem;width:", "rem;"], function (props) {
  return props.$size === 's' ? 1.6 : 2.4;
}, function (props) {
  return props.$size === 's' ? 1.6 : 2.4;
})));
var Plus = styled.span.withConfig({
  displayName: "Ratingstyle__Plus",
  componentId: "sc-1cmhm0l-1"
})(["padding-left:2px;"]);

export { Plus, Rating };
//# sourceMappingURL=Rating.style.js.map
